export default __webpack_public_path__ + "img/tremors/tremors9_700.jpg";